import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ constraint, project }) =>
    present(
      repository
        .saveConstraint(constraint, project)
        .then(({ impactedElements, ...constraint }) => ({
          constraint,
          impactedElements,
          project,
        }))
        .catch(() => Promise.reject({ constraint, project })),
    );
}

export type { Interactor };

export { createInteractor };
